import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-text-lg" }
const _hoisted_2 = { class: "p-text-sm mt-3" }
const _hoisted_3 = { class: "text-left mt-3" }
const _hoisted_4 = { class: "p-text-sm" }

import { reactive } from "vue";
import { useRoute } from "vue-router"
import { useSettingsStore } from "@/api/store/settings"
import { notificationsService } from '@/api/services/notification';
import moment from 'moment';
import { formatNotificationDate } from "@/components/Helpers/NotificationHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationView',
  setup(__props) {

const settingsStore = useSettingsStore();
const route = useRoute();

const state = reactive({
    notification: null as any,
});

const getNotifications = () => {
    
    notificationsService.show(route.params.id).then((response) => {
        state.notification = response;
        
    });
}

getNotifications();

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (state.notification)
        ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_1, _toDisplayString(state.notification.subject), 1),
                  _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(moment)(state.notification.created_at).format("LLL")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(formatNotificationDate)(state.notification.content)), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})